import React, { Fragment } from 'react';
import Slider from 'react-slick';
import ScrollAnimation from '../../ScrollAnimation/ScrollAnimation';
import { gameSelectionSliderConfig } from '../sliderConfig';
import PictureImage from '../../UI/Image/Picture';
import { getImage } from '../../../utils';

interface IGamesProps {
  games: string[];
}


const Games = ({ games }: IGamesProps) => {
  return (
    <div className="wrapper-game-list">
      <div className="ubisoft-plus_container game-selection_inner show-game-list">
        <Fragment>
          {games.map((image, index) => (
            <ScrollAnimation
              key={index}
              className="image-wrapper"
              animateIn="slide-in"
              animatePreScroll={false}
            >
              <PictureImage
                images={getImage(image)}
                extension="png"
                altText={image}
                className={[""]}
              />
            </ScrollAnimation>
          ))}
        </Fragment>
      </div>
      <div className="show-game-list-slider">
        <Slider {...gameSelectionSliderConfig()}>
          {games.map((image) => (
              <div className="slide-wrapper" key={"slide_" + image} >
                <PictureImage
                  images={getImage(image)}
                  extension="png"
                  altText={image}
                  className={[""]}
                />
              </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Games;